
import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="app-footer">
      <div className="footer-content">
        <div className="company-info">
          <p className="footer-brand">스펙터학원</p>
          <p>주소: 서울 강남구 삼성로57길 39 | 이메일: sheen3117@naver.com</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
